<template>
  <v-card class="pa-0 ma-0" :min-height="minHeight">
    <v-row class="pa-1 ma-1 mb-0 pt-2">
      <ArticleTitlesMenu :articles="articles" :loadingData="loadingData" @gotopage="goToPage"></ArticleTitlesMenu>
      <BaseCombobox
        :items="items"
        @clearitems="clearItemsHandler"
        @fillitems="fillItemsHandler"
        @selected="selectItemHandler"
        @search="runSearch"
        label="Искать в путешествиях"
        placeholder="По Европе, с детьми, Барселона"
        :initialSearchText="initialSearchText"
      ></BaseCombobox>
    </v-row>
    <v-row class="ma-0 ml-2 pa-0 caption font-italic">{{ currentArticleTitle }}</v-row>
  </v-card>
</template>

<script>
import APIService from '@/apiservices/APIService.js'
import ArticleTitlesMenu from '@/components/ArticleTitlesMenu.vue'
import BaseCombobox from '@/components/BaseCombobox.vue'

import { articlesSearchPanelMixin } from '@/components/mixins/articlesSearchPanel'

export default {
  components: {
    ArticleTitlesMenu,
    BaseCombobox
  },
  mixins: [articlesSearchPanelMixin],

  data() {
    return {
      journeys: [],
      locations: []
    }
  },

  methods: {
    fetchItemsHandler() {
      APIService.getJourneyTitles()
        .then(response => {
          this.journeys = response.data
          this.journeys = this.journeys.map(({ id, name }) => ({
            value: { journey_id: id },
            text: name,
            type: 'journey'
          }))
        })
        .catch(error => {
          console.log('There was an error in fetching journey titles:', error)
        })
      APIService.getJourneyLocations()
        .then(response => {
          this.locations = response.data
          this.locations = this.locations.map(({ id, name }) => ({
            value: { location_id: id },
            text: name,
            type: 'location'
          }))
        })
        .catch(error => {
          console.log('There was an error in fetching locations:', error)
        })
    },

    fillItemsHandler() {
      this.items = this.journeys.concat(this.locations)
    },

    selectItemHandler(item) {
      console.log(item)
      if (item && item.text != '') {
        this.clearItemsHandler()
        this.$store.dispatch('setArticlesListOptions', {
          options: item.value,
          page: 1,
          showtitles: true,
          searchText: item.text
        })
        this.$emit('search')
      }
    },

    runSearch(searchText) {
      if (searchText != '') {
        let filterOptions = { search: searchText, journey_id: 'notnull' }
        this.$store.dispatch('setArticlesListOptions', {
          options: filterOptions,
          page: 1,
          showtitles: true,
          searchText: searchText
        })
        this.$emit('search')
      }
    }
  }
}
</script>

<style></style>
